import { TEACHER_ROUTE } from 'app/teacher/routing-constants/teacher-routing.constant';

export const PORTFOLIO_ROUTE = {
  name: 'portfolio',
  route(classId: string): string[] {
    return [...TEACHER_ROUTE.ACTIVE_CLASS.route(classId), this.name];
  },

  DEFAULT: '',

  STUDENT: {
    name: 'student/:studentId',
    route(classId: string, studentId: string): string[] {
      return [...TEACHER_ROUTE.PORTFOLIO.route(classId), 'student', studentId];
    },
  },

  CLASS: {
    name: 'class',
    route(classId: string): string[] {
      return [...TEACHER_ROUTE.PORTFOLIO.route(classId), this.name];
    },
  }
};
